import Actions from 'reducers/Market'
import { ReleasesService } from 'services'
import type { AppDispatch } from 'types/store'

export const getMarkets = () => (dispatch: AppDispatch) => {
  dispatch(Actions.loadingMarkets())
  ReleasesService.getMarkets()
    .then((response: any) => {
      dispatch(Actions.loadingMarketsSuccess(response.data.items))
    })
    .catch((error: any) => {
      dispatch(Actions.loadingMarketsFail(error))
    })
}

export const getMarketLogoSrc =
  (base = 'https://images.plaympe.com/market/cancon.png', color?: string, size?: string) =>
  () => {
    let url = base.slice(0, -4)
    if (color) {
      url = url.concat(`-${color}`)
    }
    if (size) {
      url = url.concat(`-${size}`)
    }
    return url.concat('.png')
  }

export default {
  getMarkets,
  getMarketLogoSrc,
}
